// extracted by mini-css-extract-plugin
export default {"wrapper":"ProjectStatusBadge_wrapper__4aGFL"};